// extracted by mini-css-extract-plugin
export default {"content":"ConfirmationDialog_content__Sr-93","message":"ConfirmationDialog_message__7X8S5","actions":"ConfirmationDialog_actions__u6PJ+"};